import { ServicesBuilder } from '@/utils/setup';
import { AppMiscService, IAppMiscService } from '@posx/core';
import { ElNotification } from 'element-plus';
import { defineStore } from 'pinia'

// Store for handling toast notifications
export const useMiscStore = defineStore('misc', {
  state: () => ({}),

  actions: {
    // Display a toast notification with specified message and type
    toast(message: string, type: 'success' | 'error' | 'info', title?: string) {
      ElNotification({
        customClass: `x-notification__${type}`,
        title: title || (type === 'success' ? 'Success' : type === 'error' ? 'Error' : 'Info'),
        message,
        type,
      })
    },
    async getAppMiscService(): Promise<IAppMiscService> {
      return ServicesBuilder.getInstance().getService<IAppMiscService>(AppMiscService);
    }
  }
})